import React, { useState } from 'react'
import PropTypes from "prop-types";
import { distributeLead } from '../../pages/support/helper';


const DistributeLeadModal = ({ refetch, row, supportUsers, closeModal }) => {

    const [selectedUsers, setSelectedUsers] = useState([])
    const [selectedStatus, setSelectedStatus] = useState('NEW')

    const handleSelectUser = (user) => {
        if (selectedUsers.includes(user.id)) {
            setSelectedUsers(selectedUsers.filter((u) => u !== user.id))
        } else {
            setSelectedUsers([...selectedUsers, user.id])
        }
    }

    const handleDistributeLead = async () => {
        await distributeLead(row.id, selectedUsers, [selectedStatus])
        refetch()
        closeModal()
    }

    return (
        <div>
            <h1 className='text-2xl font-bold'>Distribute Lead</h1>
            <div className='flex flex-col gap-2'>
                <span className='text-md text-blacl'>Distribute the leads for <span className='font-bold'>{row.name}</span></span>
                <h2 className='text-lg font-bold'>Active Support Users</h2>
                {supportUsers?.length > 0 && <div className='flex flex-col gap-2'>
                    {supportUsers.map((user) => (
                        <div key={user.id} className='flex items-center justify-between gap-4 py-3 px-6 border-b border-gray-100 hover:bg-gray-50 transition-colors duration-200 rounded-lg'>
                            <div className='flex items-center gap-3'>
                                <input
                                    type="checkbox"
                                    onChange={() => handleSelectUser(user)}
                                    className="w-4 h-4 rounded border-gray-300 text-[#00A48B] focus:ring-[#00A48B] cursor-pointer"
                                />
                                <div className='font-medium text-gray-700'>{user.name}</div>
                            </div>
                        </div>
                    ))}
                </div>}
                <div className='flex flex-col gap-2'>
                    <h2 className='text-lg font-bold'>Lead Status</h2>
                    <select className="bg-white-50 rounded-md w-[150px] h-10 font-medium" onChange={(e) => setSelectedStatus(e.target.value)} value={selectedStatus} name="status" id="status">
                        <option value="NEW" >Pending</option>
                        <option value="CALLBACK">Callback</option>
                        <option value="NO_ANSWER">No Answer</option>
                        <option value="BYPASSED">Bypassed</option>
                        <option value="LOST">Lost</option>
                        <option value="WARM">Warm</option>
                        <option value="CONVERTED">Converted</option>
                    </select>
                </div>
                <button className='bg-[#00A48B] text-white-50 px-4 py-2 rounded-md' onClick={() => handleDistributeLead(row, supportUsers)}>Distribute</button>
            </div>
        </div>
    )
}

DistributeLeadModal.propTypes = {
    row: PropTypes.object.isRequired,
    supportUsers: PropTypes.array.isRequired,
    refetch: PropTypes.func.isRequired,
    closeModal: PropTypes.func.isRequired,
};

export default DistributeLeadModal